import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import LegacyRouteRedirect from '@/components/navigation/LegacyRouteRedirect';

/** Compatibility routes retain filters, fragments and the original access rules. */
const legacyNavigationRoutes: FuseRouteItemType[] = [
	{ path: '/bookings/:bookingId', element: <LegacyRouteRedirect to="/bookings/active/:bookingId" /> },
	{ path: '/equipment/:equipmentId', element: <LegacyRouteRedirect to="/equipment/stock/:equipmentId" /> },
	{ path: '/equipment-types', element: <LegacyRouteRedirect to="/catalog/equipment-types" /> },
	{ path: '/equipment-types/catalogue', element: <LegacyRouteRedirect to="/catalog/order" /> },
	{ path: '/equipment-types/:id', element: <LegacyRouteRedirect to="/catalog/equipment-types/:id" /> },
	{ path: '/accessories', element: <LegacyRouteRedirect to="/catalog/accessory-types" /> },
	{ path: '/accessories/:id', element: <LegacyRouteRedirect to="/catalog/accessory-types/:id" /> },
	{ path: '/categories', element: <LegacyRouteRedirect to="/catalog/categories" /> },
	{ path: '/categories/:id', element: <LegacyRouteRedirect to="/catalog/categories/:id" /> },
	{ path: '/locations/:locationId', element: <LegacyRouteRedirect to="/locations/managed/:locationId" /> },
	{ path: '/teams/shifts', element: <LegacyRouteRedirect to="/staff-shifts" /> },
	{ path: '/equipment-rentals/settlement', element: <LegacyRouteRedirect to="/partners/settlement" /> },
	{ path: '/partners/new', auth: ['Admin'], element: <LegacyRouteRedirect to="/partners/companies/new" /> },
	{
		path: '/partners/:id/edit',
		auth: ['Admin'],
		element: <LegacyRouteRedirect to="/partners/companies/:id/edit" />
	}
];

export default legacyNavigationRoutes;
